import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const MenuEditIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 24 24" sx={{ height: '24px', width: '24px', fill: 'transparent', ...sx }} {...props}>
      <path
        d="M21 18.0002L19.9999 19.0943C19.4695 19.6744 18.7502 20.0002 18.0002 20.0002C17.2501 20.0002 16.5308 19.6744 16.0004 19.0943C15.4693 18.5154 14.75 18.1903 14.0002 18.1903C13.2504 18.1903 12.5312 18.5154 12 19.0943M3.00003 20.0002H4.67457C5.16376 20.0002 5.40835 20.0002 5.63852 19.945C5.84259 19.896 6.03768 19.8152 6.21663 19.7055C6.41846 19.5818 6.59141 19.4089 6.93732 19.063L19.5001 6.50023C20.3285 5.6718 20.3285 4.32865 19.5001 3.50023C18.6716 2.6718 17.3285 2.6718 16.5001 3.50023L3.93729 16.063C3.59139 16.4089 3.41843 16.5818 3.29475 16.7837C3.18509 16.9626 3.10428 17.1577 3.05529 17.3618C3.00003 17.5919 3.00003 17.8365 3.00003 18.3257V20.0002Z"
        stroke={props.color === 'secondary' ? "#24B07E" : '#14191F'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default MenuEditIcon;
